import React, { useState, useEffect, useContext, useMemo, useRef, createRef } from "react";

import { Utils } from "common/Utils";

import Gantt from "components/frappe-gantt";
import moment from "moment";

export default function AximGantt ({ tasks, viewMode, readonly, onTasksChange, onClickTask, customClass }) {
    const [_tasks, setTasks] = useState([]);
    const [_viewMode, setViewMode] = useState(null);
    const [_gantt, setGantt] = useState(null);

    const _svg = createRef()
    const _target = createRef()

    const options = useMemo(() => {
        return {
            readonly: readonly ?? true,
            date_padding: 7,
            popup_trigger: "mouseover",
            custom_popup_html: (task) => {
                return `
                <div style=padding:15px;width:350px>
                    <h4>${task.name}</h4>
                    <h6>${task.description}</h6>
                    <p>${Utils.formatDate(task.start)} - ${Utils.formatDate(task.end)}</p>
                    <p>${task.progress}% completed!</p>
                    <p>Responsibility: ${task.responsibility}</p>
                </div>
                `;
            },
            on_date_change: (task, start, end) => {
                task.start = start;
                task.end = end;

                updateTasks(task);
            },
            on_progress_change: (task, progress) => {
                updateTasks(task);
            },
            on_click: (task) => {
                if (onClickTask) {
                    onClickTask(task);
                }
            }
        }
    },[readonly])

    useEffect(() => {
        if (!_gantt) {
            createGantt();
        }
        else {
            _gantt.refresh(tasks, options);
            _gantt.change_view_mode(viewMode);
        }
    }, [_tasks, options, _viewMode])

    const createGantt = () => {
        if (_tasks && _tasks.length > 0) {
            var g = new Gantt(_svg.current, _tasks, options);

            if (g) {
                g.change_view_mode(_viewMode);
            }

            if (_svg?.current && _target?.current) {
                const midOfSvg = _svg.current.clientWidth * 0.5;
                _target.current.scrollLeft = midOfSvg
            }

            setGantt(g);
        }
    }

    useEffect(() => {
        setTasks(tasks);
    },[tasks, options]);

    useEffect(() => {
        setViewMode(viewMode);
    }, [viewMode]);

    const updateTasks = (task) => {
        var newTasks = [..._tasks];

        var index = newTasks.findIndex(t => t.id === task.id);

        newTasks[index].start = task.start;
        newTasks[index].end = task.end;
        newTasks[index].progress = task.progress;

        setTasks(_tasks);

        if (onTasksChange) {
            onTasksChange(newTasks);
        }
    }

    return (
        <div className={customClass} style={{ overflow: "hidden" }} ref={_target}>
            <svg
                ref={_svg}
                width="100%"
                height="100%"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            />
        </div>
    )
}